// @flow

// Libs
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Types
import type {
  ComposeDataTableOptions,
  DataTableSelectors,
} from '../../types'

type Props<R> = {
  perPage: number,
  page: number,
  pages: Array<Array<R>>,
  pageRecords: Array<R>,
}

type MapDispatchToProps = {
  actions: {
    onPaginate: Function,
    onSort: Function,
  }
}

// Exports
export default function composeContainer<M, R> ({
  options,
  selectors,
  actionCreators,
  }: {
  options: ComposeDataTableOptions,
  selectors: DataTableSelectors<M, R>,
  actionCreators: { [string]: Function }
}): * {
  //
  function mapStateToProps (state: Object): Props<R> {
    return {
      perPage: selectors.perPage$(state),
      page: selectors.page$(state),
      pages: selectors.pages$(state),
      pageRecords: selectors.pageRecords$(state),
      max: selectors.max$(state),
      sortBy: selectors.sortBy$(state),
      sortDesc: selectors.sortDesc$(state),
      filters: selectors.filters$(state),
      selectedRecordIds: selectors.selectedRecordIds$(state),
    }
  }

  const mapDispatchToProps = function (dispatch: Dispatch<*>): MapDispatchToProps {
    return {
      actions: bindActionCreators({
        onPaginate: actionCreators.paginate,
        // // onChangePerPage
        onSelect: actionCreators.select,
        // // onGroupBy
        onSort: actionCreators.sort,
        onFilter: actionCreators.filter,
        // // onPreviousPage
        // // onColumnOrder
        onSelectAll: actionCreators.selectAll,
        resetDataTableState: actionCreators.resetDataTableState,
        // onClickRow
        // onClearSelection
        // onSwitchMode
      }, dispatch),
    }
  }

  return connect(mapStateToProps, mapDispatchToProps, undefined, {
    pure: true,
  })
}
